// React imports
import * as React from "react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// External library imports
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Alert, Badge, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Tooltip } from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

// Local imports
import { toggleSidebar } from "../../store/SidebarSlice";
import useAxiosInterceptor from "../layout/AxiosInstance";
import {
	ViewUser,
	changePassword,
	logout,
	viewNotificationNumber,
	viewNotifications,
} from "../../Service/Apis";
import {
	clearToken,
	setIsLoggedIn,
	setSelectedRole,
} from "../../store/AuthSlice";
import { getItems, getSidebarItems } from "../Data/data";
import { setRole } from "../../store/FormSlice";
import yoda from "../../asset/home-logo1.png";
import { setFields } from "../../store/Personslice";
import { ToastVariant, useCustomToast } from "../Methods/SnackBar";
import { fetchData } from "../../store/actions";
import { RootState } from "../../store/Store";
import { NotificationType } from "./Types/NavbarTypes";

const settings = ["Profile"];

function Navbar(): JSX.Element {
	// 1. useState declarations
	const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
	const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
	const [anchorEl3, setAnchorEl3] = useState<null | HTMLElement>(null);
	const [anchorEl4, setAnchorEl4] = useState<null | HTMLElement>(null);
	const [selectedOption, setSelectedOption] = useState<string>("");
	const [displayFunc, setDisplayFunc] = useState<Array<{ label: string; route: string }>>(
		[]
	);
	const [notification, setNotification] = useState<NotificationType[]>([]);
	const [numberOfNoti, setNumberOfNoti] = useState<number>(0);
	const [changePasswordOpen, setChangePasswordOpen] = useState(false);
	const [passwordData, setPasswordData] = useState({
		old_password: "",
		new_password: "",
		confirm_password: "",
	});
	const [passwordFocused, setPasswordFocused] = useState(false);
	const [passwordFocused1, setPasswordFocused1] = useState(false);
	const [passwordFocused2, setPasswordFocused2] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showPassword1, setShowPassword1] = useState(false);
	const [showPassword2, setShowPassword2] = useState(false);
	const [passwordError, setPasswordError] = useState<string | null>(null);

	// 2. const variables
	const roles = useSelector((state: RootState) => state.auth.roles);
	const selectedRole = useSelector((state: RootState) => state.auth.selectedRole);
	const superAdmin = getSidebarItems(roles);
	const navigate = useNavigate();
	const showToast = useCustomToast();
	const dispatch = useDispatch();
	const picture = localStorage.getItem("profileImage");
	const location = useLocation();
	const name: string = localStorage.getItem("email") || "default";
	const open = Boolean(anchorEl);
	const axiosInstance = useAxiosInterceptor();

	// 3. Function declarations
	const handleOptionClick = (option: { label: string; route: string }): void => {
		setSelectedOption(option.label);
		setAnchorEl(null);
		navigate(`/${option.route}`);
	};

	const handlehowToast = (
		message: string,
		variant: ToastVariant,
		isCloseable: boolean
	): void => {
		showToast(message, variant, isCloseable);
	};

	const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorElNav(event.currentTarget);
	};

	const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = (): void => {
		setAnchorElNav(null);
	};

	const handleCloseUserMenu = (): void => {
		setAnchorElUser(null);
	};

	const handleDispatch = (): void => {
		const refresh = localStorage.getItem("refresh");
		const token = localStorage.getItem("token");
		const data = {
			refresh: refresh,
		};
		axiosInstance
			.post(`${logout}`, data, {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			})
			.then(() => {
				localStorage.removeItem("token");
				localStorage.removeItem("role");
				localStorage.removeItem("nRole");
				localStorage.removeItem("changeRole");
				localStorage.removeItem("selectedRole");
				dispatch(setSelectedRole("Employee"));
				dispatch(setRole("employee"));
				dispatch(clearToken());
				dispatch(setIsLoggedIn(false));
			})
			.catch(() => {
				// Silent fail - logout errors are non-critical
			});
	};

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handleRoleChange = (role: string): void => {
		dispatch(setSelectedRole(role));
		setDisplayFunc(getItems(role));
		dispatch(setRole(role));
		setAnchorEl2(null);
		setAnchorEl3(null);
		navigate("/landing");
	};

	const handleClickRoles = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl2(event.currentTarget);
	};

	const handleClickRoles2 = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl3(event.currentTarget);
	};

	const handleClickNotification = (
		event: React.MouseEvent<HTMLButtonElement>
	): void => {
		setAnchorEl4(event.currentTarget);
		fetcNotificationCounthData();
	};

	const handleClose = (): void => {
		setAnchorEl(null);
	};

	const fetcNotificationCounthData = async (): Promise<void> => {
		const token = localStorage.getItem("token");
		axiosInstance
			.get(
				`${viewNotifications}${selectedRole.toLowerCase()}-role/check-notifications/`,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				setNotification(res.data);
				setNumberOfNoti(0);
			})
			.catch(() => {
				// Silent fail - notification fetch errors are non-critical
			});
	};

	const handleOpenChangePassword = (): void => {
		setChangePasswordOpen(true);
		handleCloseUserMenu();
	};

	const handleCloseChangePassword = (): void => {
		setChangePasswordOpen(false);
		setPasswordData({ old_password: "", new_password: "", confirm_password: "" });
		setShowPassword(false);
		setShowPassword1(false);
		setShowPassword2(false);
		setPasswordError(null);
	};

	const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const { name, value } = e.target;
		setPasswordData((prev) => ({ ...prev, [name]: value }));
		setPasswordError(null);
	};

	const validatePassword = (): string | null => {
		const { new_password, confirm_password } = passwordData;
		const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])(?!.*\s).{8,16}$/;
		if (!passwordRegex.test(new_password)) {
			return "The new password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character, no blank space(s). The minimum length is 8 and maximum length is 16";
		}
		if (new_password !== confirm_password) {
			return "New password and confirm password do not match";
		}
		return null;
	};

	const handleSubmitPasswordChange = async (e: React.FormEvent): Promise<void> => {
		e.preventDefault();
		setPasswordError(null);
		const validationError = validatePassword();
		if (validationError) {
			setPasswordError(validationError);
			return;
		}
		const userId = localStorage.getItem("id");
		const token = localStorage.getItem("token");
		try {
			await axiosInstance.patch(`${changePassword}${userId}/`, passwordData, {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
			});
			showToast("Password Changed Successfully", "success", true);
			handleCloseChangePassword();
		} catch (error: unknown) {
			const axiosError = error as { response?: { data?: { error?: string; message?: string } }; message?: string };
			const errorMessage = axiosError.response?.data?.message || axiosError.response?.data?.error || axiosError.message || "Failed to Change Password";
			setPasswordError(errorMessage);
		}
	};

	// 4. useEffect hooks
	useEffect(() => {
		const currentPath = location.pathname;
		const currentOption = displayFunc.find(
			(option) => `/${option.route}` === currentPath
		);
		if (currentOption) {
			setSelectedOption(currentOption.label);
		}
	}, [location.pathname, displayFunc]);

	useEffect(() => {
		setDisplayFunc(getItems(selectedRole));
	}, [selectedRole]);

	useEffect(() => {
		const fetchnumber = async (): Promise<void> => {
			const token = localStorage.getItem("token");
			axiosInstance
				.get(
					`${viewNotificationNumber}${selectedRole.toLowerCase()}-role/notification-count/`,
					{
						headers: {
							"Content-Type": "application/json",
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then((res) => {
					setNumberOfNoti(res.data.unseen_notifications);
				})
				.catch(() => {
					// Silent fail - notification count errors are non-critical
				});
		};

		fetchnumber();
	}, []);

	// 5. Return JSX
	return (
		<header>
			<AppBar position="fixed" sx={{ backgroundColor: "white" }}>
				<Container maxWidth="xl">
					
					<Toolbar disableGutters>
									{/* Hamburger for Sidebar (Visible on all screen sizes) */}
							<IconButton
								size="large"
								aria-label="toggle sidebar"
								onClick={() => dispatch(toggleSidebar())}
								color="inherit"
								sx={{ display: { xs: "flex", md: "flex" }, mr: 2 }}
							>
								<MenuIcon sx={{ color: "black" }} />
							</IconButton>
						<Typography
							variant="h6"
							noWrap
							component="a"
							sx={{
								mr: 2,
								display: { xs: "none", md: "flex" },
								fontFamily: "monospace",
								fontWeight: 700,
								letterSpacing: ".3rem",
								color: "inherit",
								textDecoration: "none",
								maxWidth: "100%",
							}}
						>
							<Link to="/landing">
								<CardMedia
									id="navbarLogo"
									component="img"
									src={yoda}
									sx={{
										width: "10rem",
										ml: 4,
										transition: "transform 0.1s ease",
										"&:hover": {
											transform: "scale(0.9)",
										},
									}}
								></CardMedia>
							</Link>
						</Typography>
						<Typography
							variant="h5"
							noWrap
							component="a"
							href=""
							sx={{
								mr: 2,
								display: { xs: "flex", md: "none" },
								flexGrow: 1,
								fontFamily: "monospace",
								fontWeight: 700,
								letterSpacing: ".3rem",
								color: "inherit",
								textDecoration: "none",
								justifyContent: "center",
							}}
						>
							<Link to="/dashboard">
								<CardMedia
									component="img"
									src={yoda}
									sx={{ width: "10rem" }}
								></CardMedia>
							</Link>
						</Typography>
						<Box
							sx={{
								flexGrow: 1,
								display: { xs: "none", md: "flex" },
								justifyContent: "right",
								mr: 2,
							}}
						>
							{displayFunc.length === 1 ? (
								<>
									<Button
										onClick={() => handleOptionClick(displayFunc[0])}
										sx={{}}
									>
										{displayFunc[0].label}
									</Button>
								</>
							) : (
								<Box>
									<Menu
										id="menu"
										anchorEl={anchorEl}
										open={Boolean(anchorEl)}
										onClose={() => setAnchorEl(null)}
									>
										{displayFunc &&
											Array.isArray(displayFunc) &&
											displayFunc.map((option, index) => (
												<MenuItem
													key={index}
													id={option.label.replace(/\s/g, "")}
													onClick={() => handleOptionClick(option)}
												>
													{option.label}
												</MenuItem>
											))}
									</Menu>
								</Box>
							)}

							<Box sx={{}}>
								
									<Button
										id="roleSwitch"
										onClick={handleClickRoles}
										endIcon={<KeyboardArrowDownIcon />}
									>
										{selectedRole}
									</Button>
								
								<Menu
									id="roleMenu"
									anchorEl={anchorEl2}
									open={Boolean(anchorEl2)}
									defaultValue={selectedRole[0]}
									onClose={() => setAnchorEl2(null)}
								>
									{roles.map((role: string, index: number) => {
										return (
											<MenuItem
												key={index}
												id={role}
												onClick={() => {
													handleRoleChange(role);
												}}
											>
												{role}
											</MenuItem>
										);
									})}
								</Menu>
							</Box>
						</Box>

						<Box sx={{ display: { xs: "flex", sm: "flex", md: "none" } }}>
							
								<Button
									id="responsiveRoleSwitch"
									onClick={handleClickRoles2}
									endIcon={<KeyboardArrowDownIcon />}
								>
									{selectedRole}
								</Button>
							
							<Menu
								anchorEl={anchorEl3}
								id="responsiveRoleMenu"
								open={Boolean(anchorEl3)}
								onClose={() => setAnchorEl3(null)}
							>
								{roles.map((role: string, index: number) => {
									return (
										<MenuItem
											key={index}
											id={role}
											onClick={() => {
												handleRoleChange(role);
											}}
										>
											{role}
										</MenuItem>
									);
								})}
							</Menu>
						</Box>

						<Box sx={{ mr: 2 }}>
							
								<IconButton
									onClick={handleClickNotification}
									id="notification"
									color="primary"
								>
									<Badge
										id="notificationCount"
										badgeContent={numberOfNoti}
										overlap="circular"
										color="primary"
										anchorOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										sx={{}}
									>
										<NotificationsNoneOutlinedIcon />
									</Badge>
								</IconButton>
							
							<Menu
								anchorEl={anchorEl4}
								open={Boolean(anchorEl4)}
								onClose={() => setAnchorEl4(null)}
								sx={{
									"& .MuiMenu-paper": {
										minWidth: 280,
										minHeight: 280,
										maxWidth: 280,
										maxHeight: 280,
									},
									overflow: "auto",
								}}
							>
								{Array.isArray(notification) && notification.length === 0 ? (
									<MenuItem
										sx={{
											justifyContent: "center",
											alignItems: "center",
											display: "center",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}
									>
										
											<Box style={{ whiteSpace: "pre-line" }}>
												No new notification
											</Box>
										
									</MenuItem>
								) : (
									Array.isArray(notification) &&
									notification.map((notifi, index) => (
										<MenuItem
											key={index}
											onClick={() => {
												const msg = notifi.message || '';
												const isComplianceMsg =
													msg.startsWith('New compliance form') ||
													msg.startsWith('REMINDER: Your compliance form') ||
													msg.startsWith('OVERDUE: Your compliance form');
												if (isComplianceMsg) {
													navigate('/compliance-templates');
												} else if (selectedRole === 'Manager') {
													navigate('/pms/kra/manager-review');
												} else if (selectedRole === 'Admin' || selectedRole === 'HR') {
													navigate('/pms/kra/hr-review');
												} else {
													// Employee notifications — use startsWith on the fixed prefix
													// so a KRA template name containing trigger words never misfires
						if (msg.startsWith('360°')) {
												navigate('/pms/360-feedback');
											} else if (msg.startsWith('New skill document')) {
												navigate('/emp-skills-document');
											} else if (msg.startsWith('Your performance review') && msg.includes('is complete')) {
												navigate('/pms/my-reviews');
											} else if (msg.startsWith('REMINDER: Self-review')) {
												navigate('/pms/my-kras');
											} else if (msg.startsWith('Peer review')) {
												navigate('/pms/peer-review/my-reviews');
											} else {
												navigate('/pms/kra/employee');
											}
												}
												setAnchorEl4(null);
											}}
											sx={{
												whiteSpace: "nowrap",
												overflow: "hidden",
												textOverflow: "ellipsis",
												cursor: "pointer",
												"&:hover": {
													backgroundColor: "rgba(0, 0, 0, 0.08)",
												},
											}}
										>
											
												<Box style={{ whiteSpace: "pre-line" }}>
													{notifi.message}
												</Box>
											
										</MenuItem>
									))
								)}
							</Menu>
						</Box>

						<Box sx={{ flexGrow: 0 }}>
							
								<IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
									<Avatar
										className="ProfileIcon"
										alt={name.toUpperCase()}
										src={picture as string}
									/>
								</IconButton>
							
							<Menu
								sx={{ mt: "45px" }}
								id="menu-appbar"
								anchorEl={anchorElUser}
								anchorOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
								keepMounted
								transformOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
								open={Boolean(anchorElUser)}
								onClose={handleCloseUserMenu}
							>
							<MenuItem id="changePassword" onClick={handleOpenChangePassword}>
								<Typography textAlign={"center"}>Change Password</Typography>
							</MenuItem>
							<MenuItem
								id="logout"
								onClick={() => {
									handleCloseUserMenu();
									handleDispatch();
									navigate("/logout");
								}}
							>
								<Typography textAlign={"center"}>Logout</Typography>
							</MenuItem>
						</Menu>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>

		{/* Change Password Dialog */}
		<Dialog
			open={changePasswordOpen}
			onClose={handleCloseChangePassword}
			aria-labelledby="change-password-title"
			disableEnforceFocus
		>
			<Box component="form" onSubmit={handleSubmitPasswordChange}>
				<Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
					<IconButton onClick={handleCloseChangePassword}>
						<CloseIcon />
					</IconButton>
				</Box>
				<DialogTitle sx={{ display: "flex", justifyContent: "center" }}>
					<Typography fontWeight={"bold"} variant="h5">
						Change Password
					</Typography>
				</DialogTitle>
				<DialogContent>
					<Box>
						<Box sx={{ display: "flex", alignItems: "center", m: 2 }}>
							<Typography fontWeight={"bold"} sx={{ width: "14rem" }}>
								Old Password :
							</Typography>
							<TextField
								id="old_password"
								autoFocus
								onFocus={() => setPasswordFocused(true)}
								onBlur={() => setPasswordFocused(false)}
								type={showPassword ? "text" : "password"}
								name="old_password"
								variant="standard"
								size="small"
								required
								value={passwordData.old_password}
								onChange={handlePasswordChange}
								sx={{ width: "16rem" }}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											{passwordFocused && (
												<IconButton
													onClick={() => setShowPassword((p) => !p)}
													edge="end"
													onMouseDown={(e) => e.preventDefault()}
												>
													{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
												</IconButton>
											)}
										</InputAdornment>
									),
								}}
							/>
						</Box>
						<Box sx={{ display: "flex", alignItems: "center", m: 2 }}>
							<Typography fontWeight={"bold"} sx={{ width: "14rem" }}>
								New Password :
							</Typography>
							<TextField
								required
								id="new_password"
								type={showPassword1 ? "text" : "password"}
								onFocus={() => setPasswordFocused1(true)}
								onBlur={() => setPasswordFocused1(false)}
								name="new_password"
								variant="standard"
								size="small"
								value={passwordData.new_password}
								onChange={handlePasswordChange}
								helperText="Must be 8 characters and should have at least one special character"
								sx={{ width: "16rem" }}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											{passwordFocused1 && (
												<IconButton
													onClick={() => setShowPassword1((p) => !p)}
													edge="end"
													onMouseDown={(e) => e.preventDefault()}
												>
													{showPassword1 ? <VisibilityOffIcon /> : <VisibilityIcon />}
												</IconButton>
											)}
										</InputAdornment>
									),
								}}
							/>
						</Box>
						<Box sx={{ display: "flex", alignItems: "center", m: 2 }}>
							<Typography fontWeight={"bold"} sx={{ width: "14rem" }}>
								Confirm Password :
							</Typography>
							<Tooltip title="Re-enter your password">
								<TextField
									required
									id="confirm_password"
									type={showPassword2 ? "text" : "password"}
									name="confirm_password"
									size="small"
									onFocus={() => setPasswordFocused2(true)}
									onBlur={() => setPasswordFocused2(false)}
									variant="standard"
									value={passwordData.confirm_password}
									onChange={handlePasswordChange}
									sx={{ width: "16rem" }}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												{passwordFocused2 && (
													<IconButton
														onClick={() => setShowPassword2((p) => !p)}
														edge="end"
														onMouseDown={(e) => e.preventDefault()}
													>
														{showPassword2 ? <VisibilityOffIcon /> : <VisibilityIcon />}
													</IconButton>
												)}
											</InputAdornment>
										),
									}}
								/>
							</Tooltip>
						</Box>
					</Box>
			</DialogContent>
			{passwordError && (
				<Alert severity="error" sx={{ mx: 3, mb: 1 }} onClose={() => setPasswordError(null)}>
					{passwordError}
				</Alert>
			)}
			<DialogActions sx={{ m: 2, p: 1 }}>
					<Button onClick={handleCloseChangePassword}>Close</Button>
					<Button
						type="submit"
						variant="contained"
						size="small"
						sx={{
							backgroundColor: "#007300",
							"&:hover": { backgroundColor: "#005500" },
						}}
					>
						Confirm
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	</header>
);
}
export default Navbar;
